import { Dispatch } from "redux";
import URLConstants from "../constants/url.constants";
import * as services from "../services/services";
import iaqRealtimeViewDataType from "../types/iaqRealtimeView.type";

export const getRealtimeViewData = (data: any) => {
  return (dispatch: Dispatch) => {
    dispatch(getRealtimeViewDataStart());
    let url =
      URLConstants.GetIAQRealtimeViewDataByICCID + "?ICCID=" + data.ICCID;
    services
      .get(url)
      .then((response) => {
        dispatch(getRealtimeViewDataSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getRealtimeViewDataError(err));
      });
  };
};

const getRealtimeViewDataStart = () => {
  return {
    type: iaqRealtimeViewDataType.GET_IAQ_REALTIME_VIEW_DATA_START,
  };
};

const getRealtimeViewDataSuccess = (data: any) => {
  return {
    type: iaqRealtimeViewDataType.GET_IAQ_REALTIME_VIEW_DATA_SUCCESS,
    payload: data,
  };
};

const getRealtimeViewDataError = (data: any) => {
  return {
    type: iaqRealtimeViewDataType.GET_IAQ_REALTIME_VIEW_DATA_ERROR,
    payload: data,
  };
};


export const resetRealtimeViewDataState = () => {
  return (dispatch: Dispatch) => {
    dispatch(resetRealtimeViewDataDispatcher());
  };
};

const resetRealtimeViewDataDispatcher = () => {
	return {
		type: iaqRealtimeViewDataType.RESET_IAQ_REALTIME_VIEW_DATA
	};
};

export const getThresholdData = (data: any) => {
  return (dispatch: Dispatch) => {
    dispatch(getThresholdDataStart());
    let url =
      URLConstants.GetIAQThresholdByICCID + "?ICCID=" + data.ICCID;
    services
      .get(url)
      .then((response) => {
        dispatch(getThresholdDataSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getThresholdDataError(err));
      });
  };
};

const getThresholdDataStart = () => {
  return {
    type: iaqRealtimeViewDataType.GET_IAQ_THRESHOLD_BY_ICCID_START,
  };
};

const getThresholdDataSuccess = (data: any) => {
  return {
    type: iaqRealtimeViewDataType.GET_IAQ_THRESHOLD_BY_ICCID_SUCCESS,
    payload: data,
  };
};

const getThresholdDataError = (data: any) => {
  return {
    type: iaqRealtimeViewDataType.GET_IAQ_THRESHOLD_BY_ICCID_ERROR,
    payload: data,
  };
};


export const resetThresholdDataState = () => {
  return (dispatch: Dispatch) => {
    dispatch(resetThresholdDataDispatcher());
  };
};

const resetThresholdDataDispatcher = () => {
	return {
		type: iaqRealtimeViewDataType.RESET_IAQ_THRESHOLD_STATE
	};
};